module.exports = __webpack_public_path__ + "gg.6d36584f.svg";